import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23011 20264"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#1c1b17;stroke-width:333.494}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275647920">
        <path
          d="M17840 1496c0 734-595 1330-1330 1330-734 0-1329-595-1329-1330 0-734 595-1329 1329-1329 735 0 1330 595 1330 1329zM12835 1496c0 734-595 1330-1330 1330-734 0-1329-595-1329-1330 0-734 595-1329 1329-1329 735 0 1330 595 1330 1329z"
          className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}
        />
      </g>
      <g id="_1970275650128">
        <path
          d="M17840 5814c0 734-595 1329-1330 1329-734 0-1329-595-1329-1329s595-1329 1329-1329c735 0 1330 595 1330 1329zM12835 5814c0 734-595 1329-1330 1329-734 0-1329-595-1329-1329s595-1329 1329-1329c735 0 1330 595 1330 1329zM7831 5814c0 734-596 1329-1330 1329s-1330-595-1330-1329 596-1329 1330-1329 1330 595 1330 1329z"
                    className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

        />
      </g>
      <g id="_1970275653392">
        <path
          d="M12835 10132c0 734-595 1330-1330 1330-734 0-1329-596-1329-1330s595-1330 1329-1330c735 1 1330 596 1330 1330zM7831 10132c0 734-596 1330-1330 1330s-1330-596-1330-1330 596-1330 1330-1330c734 1 1330 596 1330 1330zM2826 10132c0 734-595 1330-1330 1330-734 0-1329-596-1329-1330s595-1330 1329-1330c735 1 1330 596 1330 1330z"
                    className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

        />
      </g>
      <g id="_1970275652208">
        <path
          d="M17840 14451c0 734-595 1330-1330 1330-734 0-1329-596-1329-1330s595-1330 1329-1330c735 0 1330 595 1330 1330zM12835 14451c0 734-595 1330-1330 1330-734 0-1329-596-1329-1330s595-1330 1329-1330c735 0 1330 595 1330 1330zM7831 14451c0 734-596 1330-1330 1330s-1330-596-1330-1330 596-1330 1330-1330 1330 595 1330 1330z"
                    className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

        />
      </g>
      <g id="_1970275654000">
        <path
          d="M17840 18769c0 734-595 1329-1330 1329-734 0-1329-595-1329-1329 0-735 595-1330 1329-1330 735 0 1330 595 1330 1330zM12835 18769c0 734-595 1329-1330 1329-734 0-1329-595-1329-1329 0-735 595-1330 1329-1330 735 0 1330 595 1330 1330z"
                    className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

        />
      </g>
      <path
        id="_1970275654352"
        d="M22844 1496c0 734-595 1330-1329 1330s-1330-595-1330-1330c0-734 595-1329 1330-1329 734 0 1329 595 1329 1329z"
                  className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

      />
      <path
        id="_1970275655024"
        d="M22844 18769c0 734-595 1329-1329 1329s-1330-595-1330-1329c0-735 595-1330 1330-1330 734 0 1329 595 1329 1330z"
                  className="fill stroke1"
          style={{
            strokeWidth: 333.494,
          }}

      />
    </g>
  </svg>
)
export default SvgComponent
